<app-layout>

<!-- head start -->
<section class="head noselect">

  <!-- Emergency Block (spanning the entire width) -->
     <!-- <div :class="{ 'hide-on-mobile': !isMobile }"  class="emergency-block"> -->
	<div v-if="false" class="emergency-block">
        <div  class="emergency-item">
            <iframe src="https://bitzipp.com/emergency/" title="" width="100%" scrolling="no"></iframe>
        </div>
      </div>

    <!-- Content Row (split into two columns) -->
    <div class="head-row">
        <div class="head-block">
        <!-- Left Column (existing content with "The Most") -->
	<p>{{ undefinedVariable }}</p>
            <div class="head-item">
                <div class="head-title">
                <h8>{{ $t('Beyond Boundaries') }}</h8>
		<h3>{{ $t('Cryptocurrency Trading Made Simple') }}</h3>
                <h2>{{ $t('Start Small -  Dream Big: Begin Your Crypto Journey Now') }}</h2>

		<div class="try">
    <input v-model="email" placeholder="Your Email" type="email" id="FormLabel-email" class="form-components__block-input" />
    <button class="but"  @click="saveAndRedirect">Try Now</button>
  </div>

	               
            </div>
        </div>

        <!-- Right Column (content with Bitcoin Halving Countdown) -->

            <div class="head-itemn">
                <div class="head-title">
                

		   <div class="containerv">
			
    
      <video loop="loop" autoplay="autoplay" muted="muted" playsinline>
        <source src="https://bitzipp.pro/storage/uploads/videohead.mp4" type="video/mp4">
       <source src="https://bitzipp.pro/storage/uploads/test1.m4v" type="video/x-m4v">
	 Your browser does not support the video tag.
      </video>

</div></div>
	 
	</div>

   


		        
    </div>
        </div>
        </div>
    </div>
</section>


    <!-- head end -->

   <!-- features start -->
    <section class="noselect featuress">
	<!-- Emergency Block (spanning the entire width) -->
     <!-- <div :class="{ 'hide-on-mobile': isMobile }" class="emergency-block"> -->
	<div v-if="false" class="emergency-block">
        <div class="emergency-item">
            <iframe src="https://bitzipp.com/emergency/" title="" width="100%" scrolling="no"></iframe>
        </div>
      </div>

        <div class="featuress-row">
              <div v-if="articles && articles.data" class="head-carousel">
               <hooper :settings="hooperSettings">
                    <slide v-for="article in articles.data">
                            <div @click.stop="setArticle(article)" class="cursor-pointer head-carousel__item">
                                <img :src="article.thumbnail">
                            </div>
                    </slide>
                </hooper>
	    <div class="table-home__link">
                <inertia-link :href="route('articles')">{{ $t('View all') }}</inertia-link>
            </div>
            </div>

        </div>
    </section>
    <!-- featuress end -->


<section class="noselect textbitzipp">
        <div class="textbitzipp-row">
            <!-- textbitzipp title start -->
            <div class="textbitzipp-title">
                <h2>{{ $t('Simplify your crypto journey') }}</h2>
		<h3>{{ $t('Ensuring fast, secure, and reliable transactions every step of the way.') }}</h3>
			</div>
        </div>
            <!-- textbitzipp title end -->

     
    </section>



   <!-- screen start -->
    <section class="noselect startbitzipp">
        <div class="screen-row">

            <!-- screen title start -->
            <div class="screen-title">
                
		<h2>{{ $t('Exchange Walkthrough') }}</h2>




	     <div class="video-contain">
    <video class="rounded-video" width="90%" height="360" loop="loop" autoplay="autoplay" muted="muted" playsinline>
      <source :src="videoUrl" type="video/mp4">
	<source src="https://bitzipp.pro/storage/uploads/test1.m4v" type="video/x-m4v">
      Your browser does not support the video tag.
    </video>
  </div>
</div>
                </div>
            <!-- screen title end -->

            

        </div>
    </section>
    <!-- screen end -->           


<section v-if="!$page.props.user" class="noselect bitzippb">
  <div class="bitzippb__row">
<!-- banner start -->
            <div class="banner">
                <h2>{{ $t('Ready to Take Off?') }}</h2>
                <div class="banner-text">
                    <p>{{ $t('Try now and embark on a seamless currency exchange experience!') }}</p>

		    <div class="try">
    <input v-model="email" placeholder="Your Email" type="email" id="FormLabel-email" class="form-components__block-input" />
    <button class="but"  @click="saveAndRedirect">Try Now</button>
  </div>
                 </div>
	
            </div>
            <!-- banner end -->
	
</div>
</section>




<section class="noselect starbitzipp">
        <div class="bitzipp-row">

            <div class="bitzipp-block">

                  <div class="bitzipp-item">

                      <div class="bitzipp-item__title">
                         <video loop autoplay muted playsinline>
        <source src="https://bitzipp.pro/storage/uploads/videobzp.mp4" type="video/mp4">

       <source src="https://bitzipp.pro/storage/uploads/test1.m4v" type="video/x-m4v">
         Your browser does not support the video tag.
      </video>   
                    </div>

		   

                </div>


                    <div class="bitzipp-item">

                  <div class="bitzipp-item__title">
					<h1>Stake BZP Token - Unlock Opportunities</h1>
					 <p>Participate in the BitZipp staking program and unlock exclusive benefits by staking the BZP Token.</p>
					  <div class="try">
					  <button class="but"><a href="https://bitzipp.pro/staking-page/1">Stake BZP</a></button>
					  <button class="but"><a href="https://bitzipp.pro/swap">Buy BZP</a></button>
						  </div>
                                          <h7><span class="checkmark">✔</span> Reduced Trading Fees</h7>
					  <h7><span class="checkmark">✔</span> High Annual Stake Reward in BZP</h7>
                                          <h7><span class="checkmark">✔</span> Additional annual reward in USDT</h7>
                                          <h7><span class="checkmark">✔</span> Higher Affiliate Income</h7>
                                          <h7><span class="checkmark">✔</span> Whitelisting - BitZipp Crypto Card</h7>
                                          <h7><span class="checkmark">✔</span> Free Crypto Card</h7>
					
						</div>
                 </div>
            </div>
        </div>
    </section>



<!-- ResBitzipp Section start -->
<section class="noselect resbitzipp">
  <div class="resbitzipp-row">
      

    <!-- Left Part -->
    <div class="resbitzipp-blocka">
      <div class="resbitzipp-item">
        <!-- Content for the left part goes here -->
	
	
	<video loop autoplay muted playsinline :key="videoSource">
      <source :src="videoSource" type="video/mp4">
      Your browser does not support the video tag.
    </video>
	
	
      </div>
    </div>

    <!-- Right Part -->
    <div class="resbitzipp-block">
      <div class="resbitzipp-item">
        <!-- Content for the top right part goes here -->
      </div>
      <div class="resbitzipp-item resbitzipp-right-column">
        <!-- Content for the bottom right part goes here -->
	
        <div class="resbitzipp-row">
          <div class="resbitzipp-item">
            <!-- Content for the first row goes here -->
	    
            <inertia-link :href="route('markets')">
               <div class="card">
		<p class="heading">SPOT TRADE</p>
		<p>More info</p>
		<p>Lets go</p>
	      </div>   
		</inertia-link>

	    
          </div>
          <div class="resbitzipp-item">
            <!-- Content for the first row goes here -->
		<inertia-link :href="route('swap')">
               <div class="card">
                <p class="heading">SIMPLE SWAP</p>
                <p>More info</p>
                <p>Lets go</p>
              </div>
                </inertia-link>
              </div>
        </div>
        <div class="resbitzipp-row">
          <div class="resbitzipp-item">
            <!-- Content for the second row goes here -->
		<inertia-link :href="route('launchpads')">
               <div class="card">
                <p class="heading">LAUNCHPADS</p>
                <p>More info</p>
                <p>Lets go</p>
              </div>
                </inertia-link>
          </div>
          <div class="resbitzipp-item">
            <!-- Content for the second row goes here -->
		<inertia-link :href="route('stakings')">
               <div class="card">
                <p class="heading">HODL & EARN</p>
                <p>More info</p>
                <p>Lets go</p>
              </div>
                </inertia-link>
          </div>
        </div>
        <div class="resbitzipp-row">
          <div class="resbitzipp-item">
            <!-- Content for the third row goes here -->
		<a href="https://bitzipp.pro">
               <div class="card">
                <p class="heading">MARKET ANALYSIS (COMING)</p>
                <p>More info</p>
                <p>Lets go</p>
              </div>
                </a>
          </div>
          <div class="resbitzipp-item">
            <!-- Content for the third row goes here -->
		<a href="https://bitzipp.pro/page/affiliates">
               <div class="card">
                <p class="heading">AFFILIATE</p>
                <p>More info</p>
                <p>Lets go</p>
              </div>
                </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
<!-- ResBitzipp Section end -->


<section  class="noselect startbitzipp">
      <div  class="startbitzipp-row">

          <div class="startbitzipp-block">
            <h2>Join us in the world of seamless trading and discover a platform that prioritizes security, speed, and user satisfaction.</h2>
	    <h1>How to Get Started</h1>
					
			
		<div class="startbitzipp-container">
					
			<video loop="loop" autoplay="autoplay" muted="muted" playsinline>
        <source src="https://bitzipp.pro/storage/uploads/getstart.mp4" type="video/mp4">
       <source src="https://bitzipp.pro/storage/uploads/test1.m4v" type="video/x-m4v">
         Your browser does not support the video tag.
      </video>                                 

			  </div>
				
                
            </div>
		 </div>
    </section>


    <!-- home start -->
    <section class="noselect table-home">
	<div class="table-home__row">    
	    <!-- table home title start -->
            <div class="table-home__title">
                <h2>{{ $t('Market trend') }}</h2>
            </div>
            <!-- table home title end -->

            

      <table class="list-table mob-table-dashboard">
	<div class="table-home__tables">


	    <div class="table-home__table">
                <h3>{{ $t('All time 5') }}</h3>
                <table class="list-table mob-table-dashboard">

                    <tbody class="list-body">
                        <tr class="cursor-pointer" @click.prevent="setMarket(market)" v-for="market in btcMarkets">
                            <td>

                                <div class="list-body__value">
                                    <span class="list-body__img">
                                        <img :src="market.base_currency_logo"/>
                                    </span>
                                    <div class="list-body__name">
                                        <span class="list-body__name-big">{{ market.base_currency }}</span>
                                        <span class="list-body__name-small">{{ market.quote_currency }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>

                                <div class="list-body__value">
                                    <div class="list-body__name">{{ market.last }}</div>
                                </div>
                            </td>
                            <td>

                                <div class="list-body__value">
                                   <div class="list-body__name" :class="{'color-buy' : market.change > 0, 'color-sell' : market.change < 0}">{{ market.change > 0 ? '+' : ''}}{{ market.change }}%</div>
                                </div>
                            </td>

                        </tr>
                    </tbody>
                    <!-- Add footer content if needed -->
                </table>
            </div>

	
	    <div :class="{ 'hide-on-mobile': isMobile || isTablet }" class="table-home__table">
                <h3>{{ $t('Top 5') }}</h3>
                <table class="list-table mob-table-dashboard">
                    
                    <tbody class="list-body">
                        <tr class="cursor-pointer" @click.prevent="setMarket(market)" v-for="market in topMarkets">
                            <td>
                                
                                <div class="list-body__value">
                                    <span class="list-body__img">
                                        <img :src="market.base_currency_logo"/>
                                    </span>
                                    <div class="list-body__name">
                                        <span class="list-body__name-big">{{ market.base_currency }}</span>
                                        <span class="list-body__name-small">{{ market.quote_currency }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                
                                <div class="list-body__value">
                                    <div class="list-body__name">{{ market.last }}</div>
                                </div>
                            </td>
                            <td>
                                
                                <div class="list-body__value">
                                   <div class="list-body__name" :class="{'color-buy' : market.change > 0, 'color-sell' : market.change < 0}">{{ market.change > 0 ? '+' : ''}}{{ market.change }}%</div>
                                </div>
                            </td>
                            
                        </tr>
                    </tbody>
                    <!-- Add footer content if needed -->
                </table>
            </div>

	    <div :class="{ 'hide-on-mobile': isMobile }" class="table-home__table">
                <h3>{{ $t('Top Gainers') }}</h3>
                <table class="list-table mob-table-dashboard">
                    
                    <tbody class="list-body">
                        <tr class="cursor-pointer" @click.prevent="setMarket(market)" v-for="market in gainMarkets">
                            <td>
                                
                                <div class="list-body__value">
                                    <span class="list-body__img">
                                        <img :src="market.base_currency_logo"/>
                                    </span>
                                    <div class="list-body__name">
                                        <span class="list-body__name-big">{{ market.base_currency }}</span>
                                        <span class="list-body__name-small">{{ market.quote_currency }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                
                                <div class="list-body__value">
                                    <div class="list-body__name">{{ market.last }}</div>
                                </div>
                            </td>
                            <td>
                                
                                <div class="list-body__value">
                                   <div class="list-body__name" :class="{'color-buy' : market.change > 0, 'color-sell' : market.change < 0}">{{ market.change > 0 ? '+' : ''}}{{ market.change }}%</div>
                                </div>
                            </td>
                           
                        </tr>
                    </tbody>
                </table>
            </div>

            <div :class="{ 'hide-on-mobile': isMobile }" class="table-home__table">
                <h3>{{ $t('New Markets') }}</h3>
                <table class="list-table mob-table-dashboard">
                   
                    <tbody class="list-body">
                        <tr class="cursor-pointer" @click.prevent="setMarket(market)" v-for="market in newMarkets">
                            <td>
                                
                                <div class="list-body__value">
                                    <span class="list-body__img">
                                        <img :src="market.base_currency_logo"/>
                                    </span>
                                    <div class="list-body__name">
                                        <span class="list-body__name-big">{{ market.base_currency }}</span>
                                        <span class="list-body__name-small">{{ market.quote_currency }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                
                                <div class="list-body__value">
                                    <div class="list-body__name">{{ market.last }}</div>
                                </div>
                            </td>
                            <td>
                               <div class="list-body__value">
                                <div class="list-body__name" :class="{'color-buy' : market.change > 0, 'color-sell' : market.change < 0}">{{ market.change > 0 ? '+' : ''}}{{ market.change }}%</div>
                            </div>
                            </td>
                           
                        </tr>
                    </tbody>
                    <!-- Add footer content if needed -->
                </table>
            </div>

	</div>
	</div>

            <div class="table-home__link">
                <inertia-link :href="route('markets')">{{ $t('View all') }}</inertia-link>
            </div>


        </div>
    </section>
    <!-- table home end -->



<section v-if="!$page.props.user" class="noselect bitzippb">
  <div class="bitzippb__row">
<!-- banner start -->
            <div class="banner">
                <h2>{{ $t('Ready to Take Off?') }}</h2>
                <div class="banner-text">
                    <p>{{ $t('Try now and embark on a seamless currency exchange experience!') }}</p>

                    <div class="try">
    <input v-model="email" placeholder="Your Email" type="email" id="FormLabel-email" class="form-components__block-input" />
    <button class="but"  @click="saveAndRedirect">Try Now</button>
  </div>
                 </div>

            </div>
            <!-- banner end -->

</div>
</section>




<!-- bitzipplight start -->
     <section class="noselect startbitzipp">
        <div class="bitzipp-row">

            <div class="bitzipp-block">
               
		  <div class="bitzipp-item">
                      <div class="bitzipp-item__title">
						  <div class="video-contains">
							   <div class="containso">
								   <div class="contain"></div></div>
									<div class="contain-text">
                        <h4>Trade anywhere</h4>
                        <h5>Compatible with multiple devices, start trading with safety and convenience.</h5>
                        
								</div>
							  
						</div>
                    </div>
                </div> 


                                <div class="bitzipp-item">

                  <div class="bitzipp-item__title">

                    <section class="app-section">
        <div class="app-info">
            <h1 class="app-title">Get Your App for Currency Exchange</h1>
            <img src="https://bitzipp.pro/storage/uploads/qr.png" alt="QR Code" class="qr-code">
            <p>Scan the QR code or click the links below to download our currency exchange app and start trading with ease.</p>
            
            <div class="download-link">
                <a href="https://play.google.com/store/apps/details?id=com.bitzipp.myapp">
                    <img src="https://bitzipp.pro/storage/uploads/google.png" alt="Android" class="app-store-icon">
                                    </a></div>

			<div class="download-link">
			<div class="apple-phone">
                <a href="#">					
                    <img src="https://bitzipp.pro/storage/uploads/app-store.png" alt="Apple" class="app-store-icon" data-tooltip="Soon">
				</a></div></div>

                 </div>
            </div>
        </div>
    </section>



    

     


</app-layout>
